import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withMemo as _withMemo, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "uppercase text-raleway-13" }

import { SearcInputType } from "@/store/modules/GeoPlace/type";
import { GeoPlaceData } from "@/store/modules/GeoPlace/type";
import { debounce } from "@/utils/debounce/debounce";
import { IStore } from "@/store/types/StoreType";
import { computed, ref } from "vue";
import { useStore } from "vuex";

import SearchComponent from "@/components/select/SearchComponent.vue";
import { getSearchDebounce } from "@/views/AccountDetailsView/debounce/getSearchDebounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'postalcodeComponent',
  props: {
    error: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore<IStore>();



const searchPostalCode = debounce(
  getSearchDebounce,
  400,
  (target: HTMLInputElement) => 
    store.dispatch("getPostalcodePostalcode", { value: target.value })
);

const postalcode = ref(
  computed<{ data: SearcInputType[]; loading: boolean }>(
    () => store.getters.getPostalcodePostalcodeOptions
  )
);
const country = ref(
  computed<GeoPlaceData>(() => store.getters.getCountrySelectPostalCode)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-wrapper", { 'error-input mini': !!props.error }])
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$tc("Postcode")), 1),
    _withMemo([props.error, postalcode.value], () => (_openBlock(), _createElementBlock("div", { class: "account-select-double" }, [
      _createVNode(SearchComponent, {
        tabindex: 5,
        info: true,
        error: _ctx.error || '',
        type: 'number',
        maxlength: 5,
        disable: false,
        name: 'postal_code',
        options: postalcode.value?.data || [],
        onInput: _unref(searchPostalCode),
        store: 'updatePostalcodeSelectPostalCode',
        selectCallback: 'getRegionPostalcode',
        noSelect: country.value?.name?.length === 0
      }, null, 8, ["error", "options", "onInput", "noSelect"])
    ])), _cache, 0)
  ], 2))
}
}

})